<template>
  <div class="bg-white rounded-2xl shadow-lg border-l-4 border-psychology-primary p-6">
    <div class="flex items-center gap-3 mb-4">
      <div class="w-6 h-6 rounded-full bg-psychology-primary flex items-center justify-center text-white font-bold text-sm">
        🔬
      </div>
      <h3 class="text-xl font-semibold text-psychology-primary">专业心理学解读</h3>
    </div>

    <div class="space-y-6">
      <p class="text-gray-700 leading-relaxed">
        根据您的测试结果，我们为您提供以下基于心理学研究的专业解读：
      </p>

      <!-- 依恋模式分析 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2">依恋模式分析</h4>
        <p class="text-gray-700 leading-relaxed text-sm">
          您的依恋模式主要表现为<strong class="text-psychology-primary">{{ primaryType }}</strong>和<strong class="text-psychology-primary">{{ secondaryType }}</strong>特征。根据依恋理论，这表明您在关系中{{ attachmentDescription }}。
        </p>
      </div>

      <!-- 年上年下倾向分析 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2">年上年下倾向分析</h4>
        <p class="text-gray-700 leading-relaxed text-sm">
          {{ aypDescription }}
        </p>
      </div>

      <!-- 关系动态影响/关系发展建议 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2">{{ relationshipTitle }}</h4>
        <p class="text-gray-700 leading-relaxed text-sm">
          {{ relationshipAdvice }}
        </p>
      </div>

      <!-- 专业提示 -->
      <div class="mt-6 p-4 bg-gray-50 rounded-lg">
        <p class="text-sm text-gray-600">
          <strong>专业提示：</strong>本测试基于心理学量表设计，结果仅供参考。如需更深入的个人心理评估，建议咨询专业心理医生或心理咨询师。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import { getAYPLevel } from '@/utils/aypCalculator'

export default {
  name: 'ProfessionalInterpretation',
  props: {
    aypScore: {
      type: Number,
      required: true
    },
    attachmentType: {
      type: Object,
      required: true
    }
  },
  computed: {
    primaryType() {
      return this.attachmentType?.primary || ''
    },
    secondaryType() {
      return this.attachmentType?.secondary || ''
    },
    attachmentDescription() {
      const primary = this.primaryType
      if (primary === '探索-依赖型' || primary === '矛盾-动态型') {
        return '可能表现出较强的占有欲和情感需求'
      } else if (primary === '独立-回避型') {
        return '可能倾向于保持情感距离'
      } else {
        return '能够建立相对健康的亲密关系'
      }
    },
    aypDescription() {
      // const level = getAYPLevel(this.aypScore)
      if (this.aypScore >= 80) {
        return '您表现出强烈的年上倾向，这通常与对安全感和稳定性的需求有关。研究表明，年上倾向的个体往往在关系中寻求指导和保护。'
      } else if (this.aypScore >= 60) {
        return '您表现出明显的年上倾向，这反映了您对成熟和稳定关系的偏好。这种倾向通常与对安全感和指导的需求相关。'
      } else if (this.aypScore >= 40) {
        return '您的年上年下倾向处于平衡状态，这表明您在恋爱关系中保持了相对均衡的偏好。您既能够享受被照顾的感觉，也能够照顾伴侣。'
      } else {
        return '您表现出年下倾向，这可能反映了您在关系中保持较高独立性的倾向。您更倾向于扮演照顾者和引导者的角色。'
      }
    },
    relationshipTitle() {
      if (this.aypScore >= 80) {
        return '关系动态影响'
      } else if (this.aypScore >= 60) {
        return '关系平衡分析'
      } else if (this.aypScore >= 40) {
        return '关系发展建议'
      } else {
        return '关系发展建议'
      }
    },
    relationshipAdvice() {
      if (this.aypScore >= 80) {
        return '您的年上倾向可能影响您选择伴侣的标准和关系中的互动模式。理解这一倾向有助于您建立更符合您需求的恋爱关系。'
      } else if (this.aypScore >= 60) {
        return '您的年上倾向处于中等偏上水平，这在恋爱关系中相当常见。关键在于找到依赖与独立之间的平衡点。'
      } else if (this.aypScore >= 40) {
        return '您的平衡倾向使您能够适应不同类型的恋爱关系。考虑增加对关系的主动投入，参与更多共享活动，这有助于加深情感纽带。'
      } else {
        return '考虑增加对关系的主动投入，创造更多共享体验和情感连接，这有助于建立更深的亲密关系和相互依赖。'
      }
    }
  }
}
</script>

